import React from 'react';
import { observer } from 'mobx-react-lite';
import FavoriteQuoteStep from 'components/common/initiate-proposal/FavoriteQuoteStep';
import FavoriteProposalStepController from 'store/modules/initiate-quote/favoriteProposalStepController';
import { ProposalExperience } from 'store/modules/initiate-quote/types';
import RFQStepController from 'store/pages/initiate-quote/altus/step-controllers/rfqStepController';
import AltusRFQStep from '../RFQStep';

interface Props {
  proposalExperience: ProposalExperience | null;
  favoriteProposalStepController: FavoriteProposalStepController;
  rfqStepController: RFQStepController;
}

const AltusThirdStepSwitcher: React.FC<Props> = observer(
  ({ proposalExperience, favoriteProposalStepController, rfqStepController }) => {
    if (proposalExperience === 'CUSTOM') {
      return <AltusRFQStep rfqStepController={rfqStepController} />;
    }
    if (proposalExperience === 'FAVORITE') {
      return <FavoriteQuoteStep favoriteProposalStepController={favoriteProposalStepController} />;
    }

    return null;
  },
);

export default AltusThirdStepSwitcher;
